import React from "react";
import { Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setCreateWidget } from "../../redux/actions/WidgetMaker/WidgetAPI";
import {
  getCustomizedDate,
  updateChartSettingsInGraphObjectBasedOnSelection,
} from "../../redux/constants";
import moment from "moment";
import { supportedBenchmarkTraceChartTypes } from "../../redux/constants/enums";

const AlertModal = ({ setVisible, visible, description }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const isEditWidget = useSelector((state) => state.WidgetLibrary.editWidget);

  const authParams = useSelector((state) => state.Authentication.authParams);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const chartName = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.chart_property?.chart_name
  );
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);

  const modalClose = () => {
    setVisible(false);
  };

  const handleSaveWidget = () => {
    let widget_obj = {
      isEditWidget,
      id,
    };
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };
    let y_series_array = [];
    y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
      (key) => widgetGraphConfig?.y_axis[key]
    );
    y_series_array = y_series_array?.filter((e) => e?.attribute);
    let card_settings_data = [];
    widgetGraphConfig?.card_settings?.map((d) => {
      if (d?.x_axis || (d?.x_axis == null && d?.y_series)) {
        card_settings_data = [
          ...card_settings_data,
          {
            x_axis:
              d?.x_axis == null
                ? null
                : Object.keys(d?.x_axis).length == 0
                ? null
                : d?.x_axis,
            y_series: d?.y_series,
            // series_aggregation: d?.series_aggregation
            //   ? d?.series_aggregation
            //   : null,
            // benchmark_line: d?.benchmark_line ? d?.benchmark_line : false,
          },
        ];
      }
    });

    let saveObject = {
      authParams: authParams,
      data_source: data_source,
      chart: {
        chart_type: widgetGraphConfig?.chart_type,
        rich_fields_content: widgetGraphConfig?.rich_fields_content,
        chart_settings: {
          grid_config: widgetGraphConfig?.chart_settings?.grid_config,
          duration_comparison:
            widgetGraphConfig?.chart_settings?.duration_comparison,
          show_previous_duration_comparison:
            widgetGraphConfig?.chart_settings
              ?.show_previous_duration_comparison,
          show_previous_duration_data:
            widgetGraphConfig?.chart_settings?.show_previous_duration_data,
          show_data_labels: widgetGraphConfig?.chart_settings?.global_data_label
            ? widgetGraphConfig?.chart_settings?.global_data_label
            : false,
          show_details_on_card:
            widgetGraphConfig?.chart_settings?.show_details_on_card,
          show_as_median: widgetGraphConfig?.chart_settings?.show_as_median
            ? widgetGraphConfig?.chart_settings?.show_as_median
            : false, // this is used for scatter chart
          show_label_names: widgetGraphConfig?.chart_settings?.show_label_names
            ? widgetGraphConfig?.chart_settings?.show_label_names
            : false,
          duplicate_for_brands: widgetGraphConfig?.chart_settings
            ?.duplicate_for_brands
            ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
            : false,
          is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
          show_count_cards: widgetGraphConfig?.chart_settings?.data_count_card,
          card_percent: widgetGraphConfig?.chart_settings?.card_percent, //	card_percent is share of data
          chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
          gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
          total_row: widgetGraphConfig?.chart_settings?.total_row,
          split_cards: widgetGraphConfig?.chart_settings?.split_cards,
          wordcloud_color: widgetGraphConfig?.chart_settings?.wordcloud_color,
          top_posts_in_cards:
            widgetGraphConfig?.chart_settings?.top_posts_in_cards,
          show_header:
            typeof widgetGraphConfig?.chart_settings?.show_header === "boolean"
              ? widgetGraphConfig?.chart_settings?.show_header
              : true, // default to true
          chart_property: {
            chart_name: widgetGraphConfig?.chart_property?.chart_name,
            legend_position: widgetGraphConfig?.chart_property?.legend_position,
            y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
            no_of_top_posts: widgetGraphConfig?.chart_property?.no_of_top_posts,
          },
          show_marker: widgetGraphConfig?.show_marker,
          card_position: widgetGraphConfig?.card_position,
          card_limit: widgetGraphConfig?.card_limit,
          y_axes_settings: widgetGraphConfig?.y_axis_settings,
          cards_settings: card_settings_data ? card_settings_data : null,
          chart_styles: widgetGraphConfig?.chart_settings?.chart_styles || null,
          cluster_chart_type:
            widgetGraphConfig?.chart_settings?.cluster_chart_type,
          cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
        },
      },
      widget_name: chartName
        ? chartName
        : widgetGraphConfig?.chart_property?.chart_name,
      widget_description: description,

      x_axis: widgetGraphConfig?.x_axis,
      y_axes:
        widgetGraphConfig?.breakdown_by?.length > 0
          ? widgetGraphConfig?.breakdown_by
          : widgetGraphConfig?.filter_by?.length > 0
          ? widgetGraphConfig?.filter_by
          : null,
      // for filter dropdown in widget header
      filter_dropdown:
        widgetGraphConfig?.filter_dropdown?.length > 0
          ? widgetGraphConfig?.filter_dropdown
          : [],
      order_by: widgetGraphConfig?.order_by
        ? widgetGraphConfig?.order_by
        : null,
      y_series: y_series_array,
      filters: widgetGraphConfig?.filters ? widgetGraphConfig?.filters : null,
      start_date: widgetGraphConfig?.duration?.from
        ? widgetGraphConfig?.duration?.from
        : defaultDuration?.from,
      end_date: widgetGraphConfig?.duration?.to
        ? widgetGraphConfig?.duration?.to
        : defaultDuration?.to,
      brands: widgetGraphConfig?.brands
        ? widgetGraphConfig?.brands
        : brandlogicalgroup?.length > 0
        ? brandlogicalgroup
        : brands,
      isBrandModified: widgetGraphConfig?.brands ? true : false,
      utcoffset: utcOffset,
      tags: widgetGraphConfig?.tags ? widgetGraphConfig?.tags : [],
      search_text: "",
      pill: "All Widgets",
      offset: 0,
      no_of_rows: 12,
      sort_expression: "created_date",
      sort_order: "desc",
      chart_type: "",
      attribute: "",
      type: "widget-maker",
      multilevel_breakdown: widgetGraphConfig?.multilevel_breakdown,
    };
    // Check and update chart settings based on benchmark line case
    let updatedSaveObject = updateChartSettingsInGraphObjectBasedOnSelection({
      widgetGraphConfig: widgetGraphConfig,
      brandlogicalgroup: brandlogicalgroup,
      brands: brands,
      graphObject: saveObject,
    });
    if (updatedSaveObject) {
      saveObject = updatedSaveObject;
    }
    dispatch(setCreateWidget(saveObject, widget_obj));
    setVisible(false);
  };

  return (
    <Modal
      visible={visible}
      className={`p-0 previewModal ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
      // title="Alert"
      width={"40%"}
      height={"30%"}
      style={{ top: "3rem" }}
      onCancel={modalClose}
      footer={[
        <Button type="button" onClick={modalClose}>
          Close
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={handleSaveWidget}
        >
          Save
        </Button>,
      ]}
      transitionName=""
      maskTransitionName=""
    >
      <div
        className="custom_scroll1 m-2 p-15"
        style={{ height: "10rem", overflow: "auto" }}
      >
        <div className="text_heading-Slab mb-10">Warning</div>
        <div className="text_regular fontSize-16">
          <span>Are you sure you want to save widget with no data ?</span>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;
